import { useMemo } from 'react'

import type { TemplateVersionInfo } from '../../types/templateModel'

export const useReplacedTemplatesOutsideHierarchy = (
  hierarchy: TemplateVersionInfo[],
): TemplateVersionInfo[] => {
  // We're only interested in showing replacements for trailing children if there's a single trailing child
  const singleTrailingTemplate = useMemo(() => {
    const children = hierarchy[hierarchy.length - 1]?.children

    return children?.length === 1 ? children[0] : null
  }, [hierarchy])

  return useMemo(() => {
    const replaced: TemplateVersionInfo[] = []

    hierarchy.forEach((hierarchyVersion) => {
      if (
        hierarchyVersion.replaces &&
        hierarchyVersion.replacesId &&
        !hierarchy.some(
          (searchVersion) =>
            searchVersion.identifier === hierarchyVersion.replacesId,
        )
      ) {
        replaced.push(hierarchyVersion.replaces)
      }
    })

    if (
      singleTrailingTemplate?.replaces &&
      !hierarchy.some(
        (hierarchyTemplate) =>
          hierarchyTemplate.identifier ===
          singleTrailingTemplate.replaces?.identifier,
      ) &&
      !replaced.some(
        (replacedTemplate) =>
          replacedTemplate.identifier ===
          singleTrailingTemplate.replaces?.identifier,
      )
    ) {
      replaced.push(singleTrailingTemplate.replaces)
    }

    return replaced
  }, [hierarchy, singleTrailingTemplate?.replaces])
}
